import { useState } from 'react';
import Results from '../components/Results';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

function NewRequest(handleNewRequest) {
  const handleShow = () => setShow(true);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);

  return (
    <>
      <div className='d-grid gap-2 d-md-flex justify-content-md-end result-bottom-bar'>
        <Button variant='primary' onClick={handleShow}>
          New Request
        </Button>
      </div>
      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>New Request</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Please be aware that the current response will not be saved after you
          proceed to the new request.
        </Modal.Body>
        <Modal.Footer>
          <Button variant='outline-primary' onClick={handleClose}>
            Back
          </Button>
          <Button variant='primary' onClick={handleNewRequest.handleNewRequest}>
            Proceed
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
export default NewRequest;
